import WWOpenDataCom from './WWOpenDataCom';

export default WWOpenDataCom;
